//product-grid is used in list pages including search
document.addEventListener("DOMContentLoaded", function () {
    var ajaxinate = new Ajaxinate({
    container: '#product-grid',
    pagination: '.pagination__list'
    });      
});
//article-grid is used in blog/journal
document.addEventListener("DOMContentLoaded", function () {
    var ajaxinate = new Ajaxinate({
    container: '#article-grid',
    pagination: '.pagination__list'
    });      
});
